<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Fnbtransactions") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelect($event, Cinema, 'Cinema')"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="fromdate"
                  v-on:click="fromdate = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fromdate"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromdate ? 'active' : ''">{{
                  $t("From Date")
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="date"
                  v-on:click="date = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="date ? 'active' : ''">{{ $t("To Date") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  v-on:click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-4">
            <button
              :disabled="btenable"
              @click.prevent.stop="
                () => {
                  currentPage = 1;
                  GetTransactionList();
                }
              "
              class="btn-blue-lg w-100"
              style="height:40px"
            >
              {{ $tc("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material" style="margin-left: -15px;">
              <b-form-input
                v-model="searchValue"
                placeholder="Search"
                style="border-radius: 10px; width: 295px; font-size: 14px;"
              />
              <label :class="searchValue ? 'active' : ''">{{ "Search" }}</label>
            </div>
          </div>
      <div class="d-flex justify-content-end">
        <!-- <div class="text-right mb-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex" @click="onDropDownChangeValue(list.name)"
              href="#">{{ list.name }}</b-dropdown-item>
            </b-dropdown>
            </div> -->

        <!--  -->
        <div
          class="d-flex justify-content-end align-items-center mb-2"
          v-if="transactionList.length"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <span @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </span>
          <!-- <a
            href="#"
            @click="generateReport()"
            title="Download as PDF"
            class="mx-2"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->

          <span
            @click="GetTransactionList('isPdf')"
            title="Download as PDF"
            class="mx-2"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </span>
        </div>

        <div class="text-right mb-2">
          <b-dropdown id="listview" variant="outline-blue" class="custom-dropdown">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
      <!--Pdf Export Table-->
      <div class="d-none">
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a2"
          pdf-orientation="landscape"
          pdf-content-width="100%"
          @beforeDownload="beforeDownload($event)"
          ref="html2Pdf"
        >
          <div class="swc-report">
            <table
              slot="pdf-content"
              class="swc-report-table"
              border="1"
              style="white-space: normal !important"
            >
              <thead class="bg-lightgrey">
                <tr>
                  <th>{{ $tc("order") }} {{ $tc("code") }}</th>
                  <th>
                    {{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})
                  </th>
                  <th>{{ $tc("revenue") }}</th>
                  <th>{{ $tc("bookingsource") }}</th>
                  <th>
                    {{ $tc("transaction") }} {{ $tc("date") }} &
                    {{ $tc("time") }}
                  </th>
                  <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
                  <th>{{ $t("Card Number") }}</th>
                  <th>{{ $t("Refrence Number") }}</th>
                  <th>{{ $tc("offer") }}</th>
                  <th>{{ $tc("fnb") }} {{ $tc("Remarks") }}</th>
                  <th>{{ $tc("BO") }} {{ $tc("Remarks") }}</th>
                  <th>{{ $tc("view") }} {{ $tc("details") }}</th>
                </tr>
              </thead>
              <tbody
                v-for="(fnbtrans, fnbtransIndex) in transactionList"
                :key="fnbtransIndex"
                class="sph-report"
              >
                <tr>
                  <td>{{ fnbtrans.order_code }}</td>
                  <td class="text-left">{{ fnbtrans.item_with_quantity }}</td>
                  <td>
                    
                    {{
                      parseFloat(fnbtrans.fp_total_amount).toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="text-left">{{ fnbtrans.bs_source }}</td>
                  <td>{{ fnbtrans.ft_date_time}}</td>
                  <td class="text-left">{{ fnbtrans.fst_payment_mode }}</td>

                  <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.response
                              .merchant_param6
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.card
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>

                  <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.verified.reference_no
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.ref
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>

                  <td :class="fnbtrans.ft_offer_name ? 'text-left' : ''">
                    {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
                  </td>
                  <td :class="'text-left'">
                    {{ fnbtrans.ft_trx_remarks || "-" }}
                  </td>
                  <td :class="'text-left'">
                    {{ fnbtrans.bo_trx_remarks || "-" }}
                  </td>
                  <!-- <td style="text-align:center">
                <button
                  class="btn-transparent text-blue"
                  @click="toDetails(fnbtrans)"
                >
                  View More
                </button>
              </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </vue-html2pdf>
      </div>
      <!--Pdf Export Table End-->
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <!-- style="white-space: normal !important" -->
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $tc("order") }} {{ $tc("code") }}</th>
              <th>Pickup Code</th>
              <th>
                {{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})
              </th>
              <th>{{ $tc("revenue") }}</th>
              <th>{{ $tc("bookingsource") }}</th>
              <th>
                {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>Created By</th>
              <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
              <th>{{ $t("Card Number") }}</th>
                  <th>{{ $t("Refrence Number") }}</th>
              <th>{{ $tc("offer") }}</th>
              <th>{{ $tc("fnb") }} {{ $tc("Remarks") }}</th>
              <th>{{ $tc("BO") }} {{ $tc("Remarks") }}</th>
              <th>Customer Name</th>
              <th>Customer Email</th>
              <th>Customer Mobile No.</th>
              <th>Refund Status</th>
              <th>Refunded By</th>
              <th>{{ $tc("view") }} {{ $tc("details") }}</th>
              <th class="sticky-actions">Actions</th>
            </tr>
          </thead>
          <tbody
            v-for="(fnbtrans, fnbtransIndex) in transactionList"
            :key="fnbtransIndex"
            class="sph-report"
          >
            <tr>
              <td>{{ fnbtrans.order_code }}</td>
              <td>{{ fnbtrans.pickup_code || "-" }}</td>
              <td class="text-left">{{ fnbtrans.item_with_quantity }}</td>
              <td>
                {{
                  parseFloat(fnbtrans.fp_total_amount).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-left">{{ fnbtrans.bs_source }}</td>
              <td class="text-right">{{fnbtrans.ft_date_time }}</td>
              <td class="text-left">{{ fnbtrans.booking_user_name || "-" }}</td>
              <td class="text-left">{{ fnbtrans.fst_payment_mode }}</td>

              <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.response
                              .merchant_param6
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.card
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>

                  <td class="text-right">
                    <template v-if="isStarClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.verified.reference_no
                          : "-"
                      }}
                    </template>
                    <template v-else-if="isEmpireClient">
                      {{
                        fnbtrans.payment_transaction_detail
                          ? fnbtrans.payment_transaction_detail.ref
                          : "-"
                      }}
                    </template>
                    <template v-else> - </template>
                  </td>

              <td :class="fnbtrans.ft_offer_name ? 'text-left' : ''">
                {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
              </td>
              <td :class="'text-left'">
                {{ fnbtrans.ft_trx_remarks || "-" }}
              </td>
              <td :class="'text-left'">
                {{ fnbtrans.bo_trx_remarks || "-" }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.customer_name ||
                  fnbtrans.guest_name ||
                  fnbtrans.customer_name_pos ||
                  "-"
                }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.cust_email ||
                  fnbtrans.guest_email ||
                  fnbtrans.cust_pos_email ||
                  "-"
                }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.customer_mobile ||
                  fnbtrans.guest_mobile ||
                  fnbtrans.customer_mobile_pos ||
                  "-"
                }}
              </td>
              <td
                class="text-left"
                :class="isRefunded(fnbtrans) ? 'text-danger' : ''"
                :title="fnbtrans.refund_datetime || ''"
              >
                {{ isRefunded(fnbtrans) ? "Refunded" : "Not Refunded" }}
              </td>
              <td class="text-left">{{ fnbtrans.refunded_by || "-" }}</td>
              <td style="text-align: center">
                <button
                  class="btn-transparent text-blue"
                  @click="toDetails(fnbtrans)"
                >
                  View More
                </button>
              </td>
              <td class="text-nowrap sticky-actions" style="text-align: center">
                <b-button
                  size="sm"
                  variant="default"
                  class="btn-blue mr-1"
                  @click="onPrintTickets(fnbtrans)"
                  >Print Tickets</b-button
                >
                <b-button
                  size="sm"
                  variant="default"
                  class="btn-blue"
                  :disabled="isRefunded(fnbtrans)"
                  :title="isRefunded(fnbtrans) ? 'Already refunded' : ''"
                  @click="openRefund(fnbtrans)"
                  >Refund</b-button
                >
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td v-if="transactionList.length == 0" colspan="21">
                <!-- <p class="text-center">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <FnbRefund
      v-if="refundOrder"
      :key="refundOrder.order_code"
      :orderCode="refundOrder.order_code"
      :routeCinemaId="refundOrder.cinema_id"
      :onClickHandler="onRefundClose"
    />
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";

import moment from "moment";
import DatePicker from "vue2-datepicker";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";
import { getCinemaBaseURL } from "@/services/Api";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
import FnbRefund from "@/components/Partials/FnbRefund.vue";
import Printd from "printd";

export default {
  components: { DatePicker, NoRecords, VueHtml2pdf, FnbRefund },
  data() {
    return {
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 2,
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      btenable: false,
      isRoleID: true,
      transactionList: [],
      selectedCinema: "",
      cine_id: null,
      Cinemas: [],
      BookingSourceList: [],
      selectedBookingSource: "",
      bs_id: null,
      date: new Date(),
      fromdate: moment().toDate(),
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      CinemasCopy: [],
      searchCinema: "",
      searchValue: "",
      EjsData: null,
      refundOrder: null,
    };
  },
  beforeMount() {
    this.getviewingnumber();
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.GetBookingSources();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.selectedCinema = CinemaObj.cine_name;
    //   this.cine_id = CinemaObj.cine_id;
    //   this.GetTransactionList();
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.selectedCinema = CinemaObj.cine_name;
    //     this.cine_id = CinemaObj.cine_id;
    //     this.GetTransactionList();
    //   }
    // }
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
    isEmpireClient() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    isStarClient(){
      return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
    },
  },

  methods: {
    isRefunded(fnbtrans) {
      return fnbtrans.is_refund == "Y" || !!fnbtrans.refund_datetime;
    },
    // Reprint the order's F&B receipt from the cinema server the row came from
    onPrintTickets(fnbtrans) {
      const { user_id } = this.secureStore.get("USINFO");
      const routeParams = { cinema_id: fnbtrans.cinema_id };
      const payload = {
        OrderCode: fnbtrans.order_code,
        Type: "Print",
        UserID: user_id,
        isReprint: true,
        cinemaId: fnbtrans.cinema_id,
      };

      if (navigator.userAgent.toLowerCase().indexOf(" electron/") > -1) {
        if (this.$socket) {
          const baseurl = getCinemaBaseURL(fnbtrans.cinema_id);
          this.$socket.emit("on_print_ticket", { baseurl, ttype: "fnb", ...payload });
          if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
            setTimeout(() => {
              this.$socket.emit("on_print_ticket", { baseurl, ttype: "fnb-security", ...payload });
            }, 4000);
          }
        }
        return;
      }

      let loader = this.$loading.show();
      PosFnbService.GetFnbOrderEjs(payload, routeParams)
        .then(({ data }) => {
          this.EjsData = data;
          this.$nextTick(() => {
            if (this.$refs.onPrint && this.EjsData) {
              new Printd().print(this.$refs.onPrint, []);
            }
          });
        })
        .catch(this._CatchError)
        .finally(() => loader.hide());
    },
    openRefund(fnbtrans) {
      this.refundOrder = {
        order_code: fnbtrans.order_code,
        cinema_id: fnbtrans.cinema_id,
      };
    },
    onRefundClose() {
      this.refundOrder = null;
      this.GetTransactionList();
    },
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.date = new Date(e);
        this.$forceUpdate();
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(18);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    excelDownload() {
      //  let temp_arr = [];
      // new_records.map(x => {
      //   x.fnb_Records.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})

      let new_records = this.transactionList;
      // let temp_arr = this.getBoxOfficeReport;
      // temp_arr = this.getBoxOfficeReport.map(x => {
      // x.paymentData.map(z => {
      // let obj = {
      // ...x,
      // ...z
      // };
      // new_records.push(obj);
      // });
      // });
      // let temp_arr_fnb = this.getBoxOfficeFnBReport.map(p => {
      // p["booking_source"] = "FNB";
      // new_records.push(p);
      // });
      // console.log("new_records", new_records);
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      // let fulldatemonparse = function (value) {
      //   console.log("value",value)
      //   if (!value) return "-";
        
      //   else if (value === "Invalid date") return "-";
      //   else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
      //     return value
      //       ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
      //       : "-";
      //   //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
      //   //this is changed acc to mams decision
      //   else
      //     return value
      //       ? moment(value).format("DD-MM-YYYY") === "Invalid date"
      //         ? "-"
      //         : moment(value).format("DD-MMM-YYYY HH:mm")
      //       : "-";
      // };

      let data = [
        {
          sheet: "FnBTransaction Report",
          columns: [
            {
              value: "order_code",
              label: "Order Code",
            },
            {
              value: (row) => row.pickup_code || "-",
              label: "Pickup Code",
            },
            {
              value: "item_with_quantity",
              label: "Item Name (Quantity)",
            },
            {
              value: (row) =>
                row.ft_currency_name +
                parseFloat(row.ft_total_amount).toFixed(
                  this.MIN_FRACTION_DIGITS
                ),
              label: "Revenue",
            },
            {
              value: "bs_source",
              label: "Booking Source",
            },
            {
              value: (row) => moment(row.ft_date_time).format("YYYY-MM-DD HH:mm"),
              label: "Transaction Date & Time",
            },
            {
              value: (row) => row.booking_user_name || "-",
              label: "Created By",
            },
            {
              value: "fst_payment_mode",
              label: "Payment Mode",
            },
            // {
            //     value: (row) => row.payment_transaction_detail && row.payment_transaction_detail.response && row.payment_transaction_detail.response.merchant_param6 
            //                     ? row.payment_transaction_detail.response.merchant_param6 
            //                     : "-",
            //     label: "Card Number",
            // },
            {
                value: (row) => {
                  if (this.isStarClient) {
                    return row.payment_transaction_detail && row.payment_transaction_detail.response && row.payment_transaction_detail.response.merchant_param6
                      ? row.payment_transaction_detail.response.merchant_param6
                      : "-";
                  } else if (this.isEmpireClient) {
                    return row.payment_transaction_detail && row.payment_transaction_detail.card
                      ? row.payment_transaction_detail.card
                      : "-";
                  } else {
                    return "-";
                  }
                },
                label: "Card Number",
            },

            {
                value: (row) =>
                {
                  if (this.isStarClient) {
                    return  row.payment_transaction_detail && row.payment_transaction_detail.verified && row.payment_transaction_detail.verified.reference_no
                                ? row.payment_transaction_detail.verified.reference_no
                                : "-";
                  }else if (this.isEmpireClient) {
                    return row.payment_transaction_detail && row.payment_transaction_detail.ref
                                ? row.payment_transaction_detail.ref
                                : "-";
                  }else {
                    return "-";
                  }
                },
                label: "Reference Number",
            },

            {
              value: (row) => (row.ft_offer_name ? row.ft_offer_name : "-"),
              label: "Offer",
            },
            {
              value: (row) => row.ft_trx_remarks || "-",
              label: "fnb Reamrks",
            },
            {
              value: (row) => row.bo_trx_remarks || "-",
              label: "BO Renarks",
            },
            {
              value: (row) =>
                row.customer_name ||
                row.guest_name ||
                row.customer_name_pos ||
                "-",
              label: "Customer Name",
            },
            {
              value: (row) =>
                row.cust_email || row.guest_email || row.cust_pos_email || "-",
              label: "Customer Email",
            },
            {
              value: (row) =>
                row.customer_mobile ||
                row.guest_mobile ||
                row.customer_mobile_pos ||
                "-",
              label: "Customer Mobile No.",
            },
            {
              value: (row) => (this.isRefunded(row) ? "Refunded" : "Not Refunded"),
              label: "Refund Status",
            },
            {
              value: (row) => row.refunded_by || "-",
              label: "Refunded By",
            },
          ],
          content: new_records,
        },
      ];
      let cinemaName = this.selectedCinema;
      let fromDate = this.fromdate
        ? moment(this.fromdate).format("YYYY-MM-DD")
        : null;
      let toDate = this.date ? moment(this.date).format("YYYY-MM-DD") : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      let settings = {
        fileName: `FnB Transaction Report-${cinemaName}_${fromDate}_${toDate}_on${date}`,
      };
      xlsx(data, settings);
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetTransactionList();
      } else {
        this.currentPage = event;
        this.GetTransactionList();
      }
    },
    toDetails(object) {
      this.$router.push({
        name: "View F&B Transaction",
        params: { ft_id: object.ft_id },
      });
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.fetchTransactionDetail.cinema_id = x.cine_id;
                this.selectedCinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    GetBookingSources: function () {
      PosFnbService.BookingSources()
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.BookingSourceList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelect: function (event, params, type) {
      if (type == "Cinema") {
        this.selectedCinema = params.cine_name;
        this.cine_id = params.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.$store.dispatch("selectDropdownCinema", params);
      } else if (type == "BookingSource") {
        this.selectedBookingSource = params.bs_source;
        this.bs_id = params.bs_id;
      }
    },
    excelDownloadFnB(BASE_URL, type) {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        from_date: this.fromdate
          ? moment(this.fromdate).format("YYYY-MM-DD")
          : "",
        date: this.date ? moment(this.date).format("YYYY-MM-DD") : "",
        search_value: this.searchValue,
        cinema_id: this.cine_id,
        bs_id: this.bs_id,
        type: type,
      };
      let qs = createQueryString(payload);
      window.open(
        `${BASE_URL}/api/admin/reports/v2/fnbtransactionsexcel${qs}`,
        "_blank"
      );
    },
    GetTransactionList: function (type = "") {
      // this.btenable = true;
      if (this.cine_id) {
        let loader = this.$loading.show();
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          from_date: this.fromdate
            ? moment(this.fromdate).format("YYYY-MM-DD")
            : "",
          date: this.date ? moment(this.date).format("YYYY-MM-DD") : "",
          search_value: this.searchValue,
          cinema_id: this.cine_id,
          // cinema_address: this.Cinemas[this.cine_id - 1].cine_address,
          cinema_address: this.Cinemas[this.cine_id - 1]
            ? this.Cinemas[this.cine_id - 1].cine_address
            : "",
          cinema_name: this.selectedCinema,
          bs_id: this.bs_id,
          type: type,
        };
        console.log({ payload });
        PosFnbService.GetFnBTransactionsV2(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.transactionList = data.Records;
                if (this.currentPage == 1) {
                  if (data.paginationData.total >= 10) {
                    this.rows = data.paginationData.total;
                    this.selectedvalue =
                      this.selectedvalue < 10 ? 10 : this.selectedvalue;
                  } else {
                    this.rows = data.paginationData.total;
                    this.selectedvalue = data.paginationData.total;
                  }
                }
                if (type == "isPdf" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
              } else {
                this.transactionList = [];
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
                this.$toasted.show("No Records Found");
              }
            } else {
              this.transactionList = [];
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        this.$toasted.show("Please select a cinema");
      }
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
.btn-outline-blue{
  height:40px !important
}
/* Keep the action buttons visible at the right edge while the wide table scrolls */
.sticky-actions {
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: #fff;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.12);
}
thead .sticky-actions {
  background-color: #c4c5c6;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbtransactionComponents/FnbTransactions.vue